export default "__VITE_ASSET__D96uC9x8__"